import { SizingNames, styled } from '@spazious/dollhouse-theme';
import { PaletteColorsCustomizable } from '@spazious/dollhouse-theme';

export interface IconButtonProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'color'> {
  color?: PaletteColorsCustomizable;
  size?: SizingNames;
}

export const IconButton = styled.button.withConfig({
  displayName: 'IconButton',
  shouldForwardProp: (prop) => !['color', 'size'].includes(prop),
})<IconButtonProps>`
  border-radius: 50%;
  padding: var(--spacing-padding);
  transition: background-color 0.3s ease-in-out;
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  outline: none;
  border: none;
  margin: 0;
  cursor: pointer;
  font-size: 28px;
  align-items: center;
  justify-content: center;
  user-select: none;
  background-color: transparent;
  color: var(--spz-sys-color-on-surface);
  ${({ size = 'medium' }) =>
    ({
      small: `padding: calc(var(--spacing-padding) * 0.8); font-size: 20px;`,
      medium: `padding: var(--spacing-padding); font-size: 28px;`,
      large: `padding: calc(var(--spacing-padding) * 1.2); font-size: 32px;`,
    }[size])}
  &:hover {
    background-color: var(--spz-sys-color-surface-container-highest);
    color: var(--spz-sys-color-on-surface);
  }
  ${({ color }) =>
    color &&
    `
    background-color: var(--spz-sys-color-${color});
    color: var(--spz-sys-color-on-${color});
    &:hover {
      background-color: var(--spz-sys-color-${color});
      color: var(--spz-sys-color-on-${color});
    }
  `}
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
    background-color: var(--spz-sys-color-surface-container-lowest);
    color: var(--spz-sys-color-inverse-on-surface);
    &:hover {
      background-color: var(--spz-sys-color-surface-container-lowest);
      color: var(--spz-sys-color-inverse-on-surface);
    }
  `}
`;
